import curry from "../../../lib/core/functional/curry";
const ENTER_KEYCODE = 13;

export default curry(function renderView(element, props) {
    const { title, saveSiteTitle } = props;
    element.textContent = title;
    element.setAttribute("contenteditable", true);

    function onKeyDown(event) {
        const { keyCode } = event;

        if (keyCode === ENTER_KEYCODE) {
            element.blur();
            event.preventDefault();
            return false;
        }
    }

    function onFocusOut() {
        saveSiteTitle(element.textContent);
    }

    element.addEventListener("keydown", onKeyDown);
    element.addEventListener("focusout", onFocusOut, true);

    return function cleanup() {
        element.removeEventListener("keydown", onKeyDown);
        element.removeEventListener("focusout", onFocusOut);
    };
});
